export default "__VITE_ASSET__n$YrxGDB__"